import axiosInstance from "../../../api/axiosInstance";

export default {
  namespaced: true,
  state: {
    notifications: [],
    unreadCount: 0,
    loading: false,
    loaded: false,
  },
  getters: {
    notifications: (state) => state.notifications,
    unreadCount: (state) => state.unreadCount,
    loading: (state) => state.loading,
    loaded: (state) => state.loaded,
  },
  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
    setNotifications(state, payload) {
      state.notifications = payload.notifications || [];
      state.unreadCount = payload.unread_count || 0;
      state.loaded = true;
    },
  },
  actions: {
    async loadNotifications({ commit }) {
      commit("setLoading", true);
      try {
        const response = await axiosInstance.get("/notifications");
        commit("setNotifications", response.data);
        return response;
      } finally {
        commit("setLoading", false);
      }
    },
    async respondToNotification({ dispatch }, { id, type, accepted }) {
      const endpoint =
        type === "co_teacher_invite"
          ? `/notifications/${id}/respond_to_co_teacher_invite`
          : `/notifications/${id}/respond_to_student_transfer`;

      const response = await axiosInstance.post(endpoint, { accepted });
      await dispatch("loadNotifications");
      return response;
    },
  },
};
